import { writable } from 'svelte/store';
import type { QueriesType, QueryType } from '../lib/components/telematics/types';

export type FilterType = {
    // vehicles: {
    //     query: string;
    //     onlyEnabled: boolean;
    // };
    jobsToBeCompleted: {
        // city: string,
        // street: string,
        // onlyLowQuality: boolean,
        queries: QueriesType;
        quickSearch: string;
        onlyLowQuality: boolean;
        managerStorageKey: string;
    };
    planning: {
        onlyNotReady: boolean;
        driverName: string;
    };
    tacticalPlan: {
        query: string;
    };
    warehouses: {
        query: string;
    };
    maps: {
        query: string;
    };
    dashboard: {
        queries: QueriesType;
        managerStorageKey: string;
    };
    accounts: {
        query: string;
    };
};

export const filter = writable<FilterType>({
    // vehicles: {
    //     query: '',
    //     onlyEnabled: false,
    // },
    jobsToBeCompleted: {
        // city: "",
        // street: "",
        // onlyLowQuality: false,
        onlyLowQuality: false,
        queries: {},
        quickSearch: '',
        managerStorageKey: 'filterManager.jobs',
    },
    planning: {
        onlyNotReady: false,
        driverName: '',
    },
    tacticalPlan: {
        query: '',
    },
    warehouses: {
        query: '',
    },
    maps: {
        query: '',
    },
    dashboard: {
        queries: {},
        managerStorageKey: 'filterManager.dashboard',
    },
    accounts: {
        query: '',
    },
});

export const currentMainFilter = writable<any>(null);
